import React, { useState } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { EditorState,convertToRaw,ContentState} from 'draft-js';
import {constructionDocument} from "@gull";
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

const NoteInterne = (props) =>{
    const t = useTranslate();
    const [validButton,setValidButton] = useState(false)

    const [editorState,setEditorState]=useState(() => {
        if(props.allInfos?.divers_infos?.note){
            //pour avoir la valeur par défaut de la description qui peut contenir des balises HTML
            let text = props.allInfos.divers_infos.note
            const defaultHTML = text;
            const contentBlock = htmlToDraft(defaultHTML);
            const contentState = ContentState.createFromBlockArray(
                contentBlock.contentBlocks,
                contentBlock.entityMap
            );
            
            return EditorState.createWithContent(contentState);
        }else{
            EditorState.createEmpty()
        }
    })

    const toolbar = {
        options: ['inline'],
        inline: {
            options: ['bold', 'italic'],
        },
    };

    const onEditorStateChange  = (editorState) =>{
        setEditorState(editorState)
    }

    const handleClick = (action) =>{
        if(props.editPlusFacture){
            //Quand on est sur DetailDocument.jsx 
            let param = 'note'
            let textData = draftToHtml(convertToRaw(editorState.getCurrentContent()))

            props.editPlusFacture({[param]:textData, close:''})
        }
    }

    return (
        <div>
            <div className="form-group mb-3">
                <label htmlFor="Texte">{t('noteInterne')}</label>
                <Editor
                    wrapperClassName="wrapper-class"
                    editorClassName="editor-class form-control"
                    toolbarClassName="toolbar-class"
                    editorState={editorState}
                    onEditorStateChange={onEditorStateChange }
                    toolbar={toolbar}
                />
            </div>
            <div>
                <button disabled={props.validButton || validButton} className="btn btn-primary mt-2" onClick={()=>handleClick('validate')}>
                    {props.validButton || validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                </button>
            </div>
        </div>
    )
};

export default NoteInterne;